import moment from "moment-timezone";

// Rapor ekranlarının varsayılan tarih aralığı (Workspace #154): başlangıç
// içinde bulunulan ayın ilk günü 00:00, bitiş bugünün sonu — tarayıcının saat
// diliminde. Gün/ay/yıl periyot seçicili raporlar bunu kullanmaz.

export const browserTimeZone = () => Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC";

export const getMonthStart = (tz = browserTimeZone()) => moment().tz(tz).startOf("month").toDate();

export const getTodayEnd = (tz = browserTimeZone()) => moment().tz(tz).endOf("day").toDate();
